<template>
    <div class="px-3">
        <ul v-if="showTabs" class="nav nav-tabs mt-2">
            <li v-for="serviceForm in serviceForms" :key="'tab-' + serviceForm.id" class="nav-item">
                <a class="nav-link" @click.prevent="setActive(serviceForm.pan)" :class="{ active: isActive(serviceForm.pan) }" :href="'#' + serviceForm.pan">{{ serviceForm.pan }}</a>
            </li>
        </ul>
        <div :class="['py-3', {'tab-content': showTabs}]">
            <div v-for="serviceForm in serviceForms" :key="serviceForm.id" class="tab-pane fade" :class="{ 'active show': isActive(serviceForm.pan) }" :id="serviceForm.pan">
                <div class="mb-3">
                    <div v-if="serviceForm.has_duplicate" class="row">
                        <div class="col-sm-12">
                            <div class="alert alert-primary" role="alert">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-info-circle"></i> 
                                    <div><span class="font-weight-bold ml-2">INFORMATION:</span> This may be a duplicate or corrected claim.</div>
                                </div>                                            
                            </div>                                            
                        </div>
                    </div>                                                                       
                    <div v-if="serviceForm.past_due" class="row">
                        <div class="col-sm-12 h3 font-weight-bold text-danger text-center">PAST DUE</div>
                    </div>                                 
                    <div class="row">
                        <div class="col-sm-12">
                            <h4>Patient Account Number: {{ serviceForm.pan }}</h4>
                        </div> 
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <h4>Date of Service: {{ serviceForm.dos }}</h4>
                        </div> 
                    </div>                    
                    <div class="row">
                        <div class="col-sm-6 h5">Payer: {{ serviceForm.insurance_carrier }}</div>
                        <div v-if="serviceForm.past_due" class="col-sm-6 h5 text-danger">
                            Days Past Due: {{ serviceForm.days_past_due }}
                        </div>                                                                        
                    </div>
                    <div class="row">
                        <div class="col-sm-6 h5">Physician: {{ serviceForm.physician }}</div>  
                        <div :class="['col-sm-6 h5', { 'text-danger': getBalance(serviceForm) > 0 }]">
                            Balance: {{ getBalance(serviceForm) | currency }}
                        </div>                                                                                                                       
                    </div>
                    <div v-if="serviceForm.transaction" class="row">
                        <div class="col text-muted">
                            <span class="cursor-pointer" data-toggle="popover" data-placement="right" title="Financing Transaction Code" :data-content="getTransactionCode(serviceForm.transaction)">
                                <i class="fas fa-info-circle fa-lg"></i>
                                <span class="font-italic">Financed</span>
                            </span>
                        </div>
                    </div>                                   
                </div>                
                <service-lines class="mb-3" :client-id="serviceForm.client_id" :claim-id="serviceForm.claim_id" :service-form-id="serviceForm.id" :document-type-id="serviceForm.document_type_id" :lines="serviceForm.service_lines" :contract="serviceForm.contract" :allow-contracts="allowContracts" :historical="false"></service-lines>              
                <service-payments :client-id="serviceForm.client_id" :claim-id="serviceForm.claim_id" :service-form-id="serviceForm.id" :payments="serviceForm.payments" :user-applied-payments="!isFinanced && !serviceForm.transaction && allowPayments" :historical="false"></service-payments>
                <div v-if="showExternal && serviceForm.transaction" class="d-flex py-3">
                    <h5 class="font-weight-bold mr-2">RMS Documents</h5>
                    <a class="btn btn-sm btn-primary" :href="'/transactions/' + serviceForm.transaction.id + '/external/documents'" target="_blank" rel="noopener noreferrer">
                        <img src="/images/rms_bw.png" style="width:16px; height: 16px;" /> View
                    </a>
                </div>                
            </div>
        </div>               
    </div>
</template>

<script>
import ServiceLines from './ServiceLinesComponent.vue';
import ServicePayments from './ServicePaymentsComponent.vue';

export default {
    components: {
        ServiceLines,
        ServicePayments
    },
    props: {
        dataServiceForms: Array,
        isFinanced: Number,
        showExternal: Number,
        allowContracts: Boolean,
        allowPayments: Boolean
    },
    data() {
        return {
            activeTab: this.dataServiceForms[0].pan,
            serviceForms: this.dataServiceForms
        }
    },
    computed: {
        showTabs: function () {
            return this.serviceForms.length > 1;
        }
    },
    methods: {
        getTotal: function (type, serviceForm) {
            var retval = 0;

            if (type == 'reimbursement') {
                retval = serviceForm.service_lines.reduce((a, b) => a + parseFloat(b.estimated_reimbursement), 0);
            }
            else if (type == 'payments') {
                retval = serviceForm.payments.reduce((a, b) => a + parseFloat(b.amount), 0);
            }

            return retval;
        },        
        getBalance: function (serviceForm) {
            return this.getTotal('reimbursement', serviceForm) - this.getTotal('payments', serviceForm);
        },
        isActive: function (tab) {
            return this.activeTab === tab;
        },        
        setActive: function (tab) {
            this.activeTab = tab;
        },
        getTransactionCode: function (transaction) {
            let retval = transaction.transaction_code;
            if (transaction.legacy_finance_code) {
                retval = retval + '/' + transaction.legacy_finance_code;
            }
            return retval;
        }                           
    },
    created() {

        // set up event listener for each service form
        for (let i = 0; i < this.serviceForms.length; i++) {

            let channel = `service-form-event.${this.serviceForms[i].id}`;
            window.Echo.private(channel)
                .listen('ServiceFormEvent', (e) => {
                    this.$set(this.serviceForms, i, e.service);
                });
        }
    }
}
</script>

<style scoped>
    .transaction-info-icon {
        font-size: .60em;
        font-weight: bold;
    }

    .nav-tabs > li > a.nav-link.active  {
        font-weight: bold;
        background-color: #fff;
    }
    
    .nav-tabs > li > a {
      background-color: #dedede;
      border-color: #fff;
    }
</style>